import { Button, Form, Input, message, Popover, Table, Tooltip } from "antd";
import { useContext, useState } from "react";
import { RiFileExcel2Line, RiMailSendLine } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import { IoTrashBinOutline } from "react-icons/io5";
import {
  blobToDataUrl,
  ExportToExcel,
  getExportData,
} from "../../../utils/exportExcel";

import { postDataMail } from "../../../services/mail";
import { useQuery } from "@tanstack/react-query";
import Something from "../../../components/shared/Something";
import { handleFetchSuppliers } from "../../../api/suppliers";
import Wrap from "../Wrap";
import { AiOutlinePlus } from "react-icons/ai";
import CreateContact from "../../manage/contacts/components/CreateContact";
import UpdateContact from "../../manage/contacts/components/UpdateContact";
import DeleteContact from "../../manage/contacts/components/DeleteContact";
import CreateSupplier from "../../manage/suppliers/components/CreateSupplier";
import { AuthContext } from "../../../context/AuthContext";

export default function Suppliers() {
  const { auth } = useContext(AuthContext);
  const [selected, setSelected] = useState<any>({});
  const [isMailLoading, setMailLoading] = useState<boolean>(false);
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [messageModal, toggleMessageModal] = useState(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  const createAccess = [2, 3, 4];

  const isError = false;
  const isLoading = false;
  const isFetching = false;
  const suppliers: any = [];
  const refetch = () => {};

  const [emailForm] = Form.useForm();

  const columns = [
    {
      title: "S/N",
      width: 40,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Name",
      width: 120,
      render: (record: any) => {
        return (
          <span className="text-gray-700">
            {record?.name ? record?.name : "-"}
          </span>
        );
      },
    },
    {
      title: "Mobile",
      width: 120,
      render: (record: any) => {
        return (
          <span className="text-gray-700">
            {record?.mobile ? record?.mobile : "-"}
          </span>
        );
      },
    },
    {
      title: "Email",
      width: 120,
      render: (record: any) => {
        return (
          <span className="text-gray-700">
            {record?.email ? record?.email : "-"}
          </span>
        );
      },
    },
    {
      title: "Address",
      width: 120,
      render: (record: any) => {
        return (
          <span className="text-gray-700">
            {record?.address ? record?.address : "-"}
          </span>
        );
      },
    },
    {
      title: "TIN",
      width: 120,
      render: (record: any) => {
        return (
          <span className="text-gray-700">
            {record?.tin ? record?.tin : "-"}
          </span>
        );
      },
    },
    {
      title: "Category",
      width: 120,
      render: (record: any) => {
        return (
          <span className="text-gray-700">
            {record?.isCompany ? (
              <div className="">Company</div>
            ) : (
              <div className="">Individual</div>
            )}
          </span>
        );
      },
    },
    {
      title: "Segment",
      width: 120,
      render: (record: any) => {
        return (
          <span className="text-gray-700">{record?.industries?.name}</span>
        );
      },
    },
    {
      title: "Action",
      width: 100,
      render: (record: any) => (
        <div className="flex justify-end">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setUpdateModal(true);
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
          >
            <FiEdit />
          </button>

          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setDeleteModal(true);
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-pointer"
          >
            <IoTrashBinOutline />
          </button>
        </div>
      ),
    },
  ];

  const sendMail = async (values: any) => {
    setMailLoading(true);
    const mapped = suppliers?.map((item: any, index: number) => {
      return {
        "S/N": index + 1,
        Name: item?.name === null ? "-" : item?.name,
        Mobile: item?.mobile === null ? "-" : item?.mobile,
        Email: item?.email === null ? "-" : item?.email,
        Address: item?.address === null ? "-" : item?.address,
        TIN: item?.tin === null ? "-" : item?.tin,
        Category: item?.isCompany ? "Organization" : "Individual",
      };
    });

    const raw = getExportData(mapped);
    const uri = await blobToDataUrl(raw);

    const maildata = {
      email: values.email,
      subject: values.subject,
      data: uri,
    };

    const mailuri = "mail";

    await postDataMail({ data: maildata, uri: mailuri });
    setMailLoading(false);

    message.success("Email Sent Successfully");
    emailForm.resetFields();
    toggleMessageModal(false);
  };

  return (
    <Wrap
      active="Suppliers"
      child={
        <CreateSupplier isVisible={createModal} setVisible={setCreateModal} />
      }
      actions={
        <>
          <div className="flex items-center">
            <Popover
              content={
                <>
                  <Form
                    name="basic"
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    form={emailForm}
                    onFinish={sendMail}
                    autoComplete="off"
                  >
                    <Form.Item
                      label="Email"
                      name="email"
                      rules={[{ required: true, message: "Email is Required" }]}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>
                    <Form.Item
                      label="Subject"
                      name="subject"
                      rules={[
                        { required: true, message: "Subject is Required" },
                      ]}
                    >
                      <Input placeholder="Email Subject" />
                    </Form.Item>
                    <div className="flex flex-row justify-between">
                      <Form.Item wrapperCol={{ offset: 12, span: 8 }}>
                        <Button type="primary" danger htmlType="submit">
                          {isMailLoading ? "Sending ..." : "Submit"}
                        </Button>
                      </Form.Item>

                      <Form.Item wrapperCol={{ offset: 0, span: 8 }}>
                        <Button
                          onClick={() => {
                            toggleMessageModal(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </>
              }
              title="Message Content"
              trigger="focus"
              placement="bottom"
              open={messageModal}
            >
              <Tooltip title="Send Email">
                <button
                  className="flex ml-2 justify-center items-center border px-4 py-1 hover:bg-gray-100"
                  onClick={async () => {
                    toggleMessageModal(true);
                  }}
                >
                  <RiMailSendLine size={20} />
                </button>
              </Tooltip>
            </Popover>
            <button
              className="border bg-white px-4 ml-2 py-1"
              onClick={() =>
                ExportToExcel(
                  suppliers?.map((item: any, index: number) => {
                    return {
                      "S/N": index + 1,
                      Name: item?.name === null ? "-" : item?.name,
                      Mobile: item?.mobile === null ? "-" : item?.mobile,
                      Email: item?.email === null ? "-" : item?.email,
                      Address: item?.address === null ? "-" : item?.address,
                      TIN: item?.tin === null ? "-" : item?.tin,
                      Category: item?.isCompany ? "Organization" : "Individual",
                    };
                  }),
                  "Suppliers.xlsx"
                )
              }
            >
              <RiFileExcel2Line size={20} />
            </button>
            {createAccess?.includes(auth?.accessLevel) && (
              <Button
                className="bg-white rounded-none ml-2 flex justify-center items-center"
                style={{ fontSize: 12 }}
                onClick={() => setCreateModal(true)}
              >
                <div className="">
                  <AiOutlinePlus size={12} />
                </div>
                <div className="ml-1 pt-1">New</div>
              </Button>
            )}
          </div>
        </>
      }
    >
      {isError ? (
        <Something refetch={refetch} isFetching={isFetching} />
      ) : (
        <div className="grid gap-x-0 grid-cols-12 border bg-white m-2">
          <div className="col-span-12 sm:col-span-12 md:col-span-12">
            <Table
              size="small"
              dataSource={suppliers === undefined ? [] : []}
              columns={columns}
              scroll={{ y: 660, x: 0 }}
              rowKey="id"
              loading={isLoading}
            />

            <UpdateContact
              isVisible={updateModal}
              setVisible={setUpdateModal}
              selected={selected}
            />

            <DeleteContact
              isVisible={deleteModal}
              setVisible={setDeleteModal}
              selected={selected}
            />
          </div>
        </div>
      )}
    </Wrap>
  );
}
